<template>
  <el-dialog
    width="40%"
    class="dialog"
    title="旧机补贴发放审核"
    :visible.sync="dialogFormVisible"
  >
    <el-form
      ref="ruleForm"
      label-position="right"
      :rules="rules"
      :model="formData"
      label-width="140px"
    >
      <el-form-item label="旧机品牌" class="read-only">{{
        formData.oldMachineBrand
      }}</el-form-item>
      <el-form-item label="旧机品类" class="read-only" prop="address">{{
        formData.oldMachineType
      }}</el-form-item>
      <el-form-item label="旧机规格" class="read-only" prop="recoveryNum">{{
        formData.oldMachineSpecification
      }}</el-form-item>
      <el-form-item label="鉴定补贴金额" class="read-only">{{
        formData.subsidyAmount
      }}</el-form-item>
      <el-form-item label="渠道" class="read-only">{{
        formData.channel
      }}</el-form-item>
      <el-form-item label="收款人" class="read-only">{{
        formData.payeeName
      }}</el-form-item>
      <el-form-item label="收款人手机号" class="read-only">{{
        formData.payeeTel
      }}
        <span v-if="formData.payeeTel">
            <img v-if="!dataVisible.payeeTel" src="@/assets/eye-close.png" @click="toggleVisibility('payeeTel')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('payeeTel')" />
          </span>
      </el-form-item>
      <el-form-item label="反向开票签名图片" class="read-only mb-10">
        <template v-if="formData.reverseInvoicingAgreementSignature">
          <image-upload
            class="img-box"
            :imageUrl.sync="formData.reverseInvoicingAgreementSignature"
            :editMode="false"
          />
        </template>
      </el-form-item>
      <el-form-item label="反向开票协议" class="read-only">
        <template v-if="formData.reverseInvoicingAgreement">
          <image-upload
            class="img-box"
            :imageUrl.sync="formData.reverseInvoicingAgreement"
            :editMode="false"
          />
        </template>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun"
        >审核通过</el-button
      >
      <el-button type="primary" @click="goReject()">审核驳回</el-button>
    </div>
    <rejectDialog
      @verifySuccess="closeDialog"
      ref="rejectDialogRef"
    ></rejectDialog>
  </el-dialog>
</template>
<script>
import rejectDialog from "./rejectDialog";

import imageUpload from "@/views/COldForNewService/components/ImageUpload";
export default {
  components: { imageUpload, rejectDialog },
  data() {
    return {
      dialogFormVisible: false,
      //订单 id
      orderNo: "",
      // 表单数据
      formData: {},
      pass: 1, //审核通过
      rules: {
        appointDate: [
          { required: true, message: "请选择预约时间段", trigger: "blur" },
        ],
        carrierNo: [
          {
            required: true,
            message: "请选择承运商",
            trigger: "blur",
          },
        ],
        recoveryWorker: [
          {
            required: true,
            message: "请选择回收师傅",
            trigger: "blur",
          },
        ],
      },
      btnLoading: false,
      payeeTel:'',
      dataVisible: {
        payeeTel: false
      },
      originData: {},
    };
  },
  computed: {
    baseUrl() {
      return process.env.BASE_API;
    },
  },
  watch: {},
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },
    // 打开弹框
    async openDialog(id) {
      this.orderNo = id;
      this.dialogFormVisible = true;
      this.HttpService.post(
        `/autoapp-default-server-recovery/api/oldMachineSubsidy/getSubsidyVerifyInfoBySubsidyNo/${id}`
      ).then(async (res) => {
        if (res.statusCode === 200) {
          this.formData = res.data;
          this.originData = res.data ? { ...res.data } : {};
          // 根据 sensitizationCode 拆分数据
        if (res.data.desensitizationDtoList && Array.isArray(res.data.desensitizationDtoList)) {
          const phoneMappings = {
            payeeTel_phone: 'payeeTel',
          }

          res.data.desensitizationDtoList.forEach(item => {
            const targetProperty = phoneMappings[item.sensitizationCode]
            if (targetProperty) {
              this[targetProperty] = {
                sensitizationCode: item.sensitizationCode,
                message: item.message
              }
            }
          })
        }
          if (res.data.reverseInvoicingAgreement) {
            if (res.data.reverseInvoicingAgreement.startsWith("http")) {
              this.formData.reverseInvoicingAgreement =
                res.data.reverseInvoicingAgreement;
            } else {
              this.formData.reverseInvoicingAgreement = await this.changeImg(
                res.data.reverseInvoicingAgreement
              );
            }
          }

          if (res.data.reverseInvoicingAgreementSignature) {
            if (res.data.reverseInvoicingAgreementSignature.startsWith("http")) {
            } else {
              this.formData.reverseInvoicingAgreementSignature =
                await this.changeImg(
                  res.data.reverseInvoicingAgreementSignature
                );
            }
          }
        }
      });
    },
    async changeImg(imgUrl) {
      if (imgUrl) {
        const response = await this.axios({
          url: `${this.baseUrl}/autoapp-default-server-recovery/api/sms-annex/download-file?fileId=${imgUrl}`,
          method: "GET",
          headers: { Authorization: this.$store.getters.token },
        });
        return response.request.responseURL;
      }
    },

    // 确认审核通过
    submitBtnFun() {
      let params = {};
      params.subsidyNos = [this.orderNo];
      params.pass = this.pass;
      // this.listLoading = true;
      this.HttpService.post(
        "/autoapp-default-server-recovery/api/oldMachineSubsidy/verifyOldMachineSubsidy",
        params
      ).then((res) => {
        if (res.statusCode == 200) {
          this.$message.success("审核成功");
          this.dialogFormVisible = false;
          this.$emit("verifySuccess");
        } else {
          this.$message.error(message);
        }
      });
    },
    // 审核驳回
    goReject() {
      this.$refs.rejectDialogRef.openDialog(this.orderNo);
    },

    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data
        }
      })
    },
    toggleVisibility(dataType) {
      // 切换显示状态
      this.dataVisible[dataType] = !this.dataVisible[dataType]

      // 根据不同类型处理显示逻辑
      switch (dataType) {
        case 'payeeTel':
          if (this.dataVisible.payeeTel && this.payeeTel.message) {
            this.getSourceOrigin(this.payeeTel).then(res => {
              this.$set(this.formData, 'payeeTel', res)
            })
          } else if (!this.dataVisible.payeeTel) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'payeeTel', this.originData.payeeTel)
          }
          break
      }
    }
  },
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .el-dialog__body {
    padding-top: 10px;
    .mb-10 {
      margin-bottom: 10px !important;
    }
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldMachineSubsidy/components/OldMachineSubsidyDistributionDialog.vue